module.exports = __webpack_public_path__ + "img/tarot-major-arcana-01.0a885826.png";